/* Add Header background on header hover*/
$(document).ready(function() {
  var header = $('.shopify-section-group-header-group');
  var timeoutId;
  header.hover(
    function() {
      clearTimeout(timeoutId);
      $(this).addClass('hovered-header');
    },
    function() {
      var $this = $(this);
      timeoutId = setTimeout(function() {
        $this.removeClass('hovered-header');
      }, 300);
    }
  );
});
/* Add Header background on header hover*/

/* Close menus on click away*/
$(document).ready(function() {
  $('.header__menu-disclosure').on('click', function() {
      $(this).attr('aria-expanded', 'false');
  });
});
/* Close menus on click away*/

/* Product Tabs */
$(document).ready(function(){
  var $newDivTitle = $('<div>'); 
  $newDivTitle.addClass('tab-links-title'); 

  var $newDivContent = $('<div>'); 
  $newDivContent.addClass('tab-links-content'); 

    $('.product-info__block-item .tab-title').each(function(index, element) {
      $(this).attr('data-tab', 'tab-' + index  ); 

      if(  index  == 0){
        $(this).addClass('tab-active');
      }

      $newDivTitle.append($(this).clone()); 
    });

  $('.product-info__block-item .tab-content').each(function(index, element) {
     $(this).attr('id', 'tab-' + index );
     if(  index  == 0){
        $(this).addClass('active');
      }
    $newDivContent.append($(this).clone()); 
  });

  $('.tab-links').append($newDivTitle);
  $('.tab-links').append($newDivContent);

  $('.tab-links-content .tab-content').fadeOut('slow');
  $('.tab-links-content .tab-content').first().fadeIn('slow');

  $('.tab-title').on('click', function() {
    var tabId = $(this).data('tab');
    $('.tab-links-content .tab-content').removeClass('active').fadeOut('slow');
    $('.tab-links-content #' + tabId).addClass('active').fadeIn('slow');
    $('.tab-title').removeClass('tab-active');
    $(this).addClass('tab-active');
  });  
});
/* Product Tabs*/

/* Sticky scrolling content */
$(document).ready(function() {
  $('.shopify-section--scrolling-content').each(function() {
      if ($(this).find('.scroll-sticky_txt').length > 0) {
        $(this).addClass('scroll-sticky_txt');
      }
  });
});
/* Sticky scrolling content */

/* PDP Swatches */
$(document).ready(function() {
  $('.pl-swatches__link').each(function() {
      if ($(this).find('.pl-swatches__swatch-wrapper--active').length > 0) {
        $(this).addClass('pl_swatch_active');
      }
  });
});
/* PDP Swatches */

/* Search header background*/
$(document).ready(function () {
  $('.icon-search').click(function () {
    $('.header').addClass('header_bg');
  });
  $(".icon-close").click(function () {
      $(".header").removeClass("header_bg");
  });
});
/* Search header background*/

/* PDP video autoplay*/
 $(document).ready(function() {
    $("#pdp-media").trigger("click");
  });
/* PDP video autoplay*/

 /*PDP size guide*/
 $(document).ready(function(){
   $(document).on("click",".conversion",function() {
    $(this).addClass('active');
    $('.measurements').removeClass('active');
    $('#measurements').css("display", "none");
    $('#conversion').css("display", "block");
  });

 $(document).on("click",".measurements",function() {
    $(this).addClass('active');
    $('.conversion').removeClass('active');
    $('#measurements').css("display", "block");
    $('#conversion').css("display", "none");
  });

/*Hide colour swatch PLP*/
setTimeout(function() {
 $('.product-card .pl-swatches-collection__container').each(function() {
   var colorCount = $(this).find('a').length;
    if (colorCount <= 1) {
      $(this).hide();
    }else{
      $(this).show();
    }
  });
}, 700);
/*Hide colour swatch PLP*/
});
/*PDP size guide*/

